import axios from "axios";

export const GET_COLEGIATURAS_LIST    = "GET_COLEGIATURAS_LIST";

export const getColegiaturasList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getColegiaturasList");
        axios
            .get("/api/ReporteAdministrativo/ObtieneColegiatura")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_COLEGIATURAS_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_COLEGIATURAS_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

